import React, { useMemo } from 'react';

/**
 * The flowing purple line-field used across veritage.io heroes — a bundle of sine
 * curves with slightly offset phase/amplitude so they braid into a ribbon.
 */
export default function WaveLines({
  className = '',
  lines = 26,
  width = 1600,
  height = 420,
  amplitude = 90,
  color = '#9F6DF3',
  opacity = 0.55,
  animate = false,
  style,
}) {
  const paths = useMemo(() => {
    const out = [];
    const steps = 80;
    for (let i = 0; i < lines; i++) {
      const t = i / (lines - 1);
      const amp = amplitude * (0.55 + 0.45 * Math.sin(t * Math.PI));
      const phase = t * 1.6;
      const yOffset = height / 2 + (t - 0.5) * height * 0.22;
      let d = '';
      // Draw two periods so the animated version can loop by translating -50%.
      const span = animate ? width * 2 : width;
      for (let s = 0; s <= steps * (animate ? 2 : 1); s++) {
        const x = (s / (steps * (animate ? 2 : 1))) * span;
        const k = (x / width) * Math.PI * 2;
        const y = yOffset + Math.sin(k * 1.1 + phase) * amp + Math.sin(k * 2.3 - phase * 0.7) * amp * 0.25;
        d += `${s === 0 ? 'M' : 'L'}${x.toFixed(1)} ${y.toFixed(1)} `;
      }
      out.push({ d, o: 0.25 + 0.75 * Math.sin(t * Math.PI) });
    }
    return out;
  }, [lines, width, height, amplitude, animate]);

  return (
    <svg
      className={`vt-waves ${className}`}
      viewBox={`0 0 ${width} ${height}`}
      preserveAspectRatio="none"
      aria-hidden="true"
      style={style}
    >
      <defs>
        <linearGradient id="vt-wave-fade" x1="0" x2="1" y1="0" y2="0">
          <stop offset="0" stopColor={color} stopOpacity="0" />
          <stop offset="0.25" stopColor={color} stopOpacity="1" />
          <stop offset="0.75" stopColor={color} stopOpacity="1" />
          <stop offset="1" stopColor={color} stopOpacity="0" />
        </linearGradient>
      </defs>
      <g
        stroke={animate ? color : 'url(#vt-wave-fade)'}
        strokeWidth="1"
        style={animate ? { animation: 'vt-wave-drift 40s linear infinite' } : undefined}
      >
        {paths.map((p, i) => (
          <path key={i} d={p.d} strokeOpacity={p.o * opacity} />
        ))}
      </g>
    </svg>
  );
}
